export const SENSITIVE_FIELD = Object.freeze({
  EMAIL: 'email',
  PHONE: 'phone',
  CELLPHONE: 'cellphone',
  FULL_ADDRESS: 'fullAddress',
  CPF_CNPJ: 'cpfCnpj',
  REPRESENTATIVE_CPF: 'representativeCpf',
  BIRTH_DATE: 'birthDate',
  CHASSIS: 'chassis',
});
